import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import useFidelityMaximizer from './useFidelityMaximizer'

const SCENARIO_COPY_KEYS: Record<string, string> = {
  nothing: 'scenario_1',
  nlbp_classic_only: 'scenario_1',
  nlbp_personalized_only: 'scenario_3',
  myselectra_no_app: 'scenario_4',
}

const resolveCopyKey = (baseCopyKey: string | undefined, isPdlEligible: boolean): string | undefined => {
  if (baseCopyKey !== 'scenario_1') {
    return baseCopyKey
  }

  return isPdlEligible ? 'scenario_1_with_pdl' : 'scenario_1_without_pdl'
}

const FidelityMaximizer = () => {
  const { t, hidden, loading, isPdlEligible, scenarioKey, actionAvailable, actionLoading, triggerAction } =
    useFidelityMaximizer()

  if (hidden) {
    return null
  }

  const isFullyLoyal = scenarioKey === 'fully_loyal'
  const baseCopyKey = SCENARIO_COPY_KEYS[scenarioKey ?? '']
  const copyKey = resolveCopyKey(baseCopyKey, isPdlEligible)
  const canShowActionCard = actionAvailable && copyKey
  const proposesMyselectra = copyKey === 'scenario_1_with_pdl' || copyKey === 'scenario_3'

  // SDNotification.primaryText is injected via dangerouslySetInnerHTML (see V1ContractWarning),
  // so the title/script copy can be combined into a single formatted string here.
  const scriptHtml = copyKey
    ? `<strong>${t(`subscriptionForm:fidelity_maximizer_module.${copyKey}.card_title`)}</strong><br />${t(
        `subscriptionForm:fidelity_maximizer_module.${copyKey}.script`,
      )}`
    : ''

  return (
    <>
      <SDNotification
        hidden={!isFullyLoyal}
        type='positive'
        primaryText={`🏆 ${t('subscriptionForm:fidelity_maximizer_module.maximized_label')}`}
      />

      <SDNotification
        hidden={isFullyLoyal || isPdlEligible}
        type='warning'
        primaryText={t('subscriptionForm:fidelity_maximizer_module.pdl_missing_warning')}
      />

      <SDNotification
        hidden={isFullyLoyal || !isPdlEligible}
        type='positive'
        primaryText={t(
          proposesMyselectra
            ? 'subscriptionForm:fidelity_maximizer_module.pdl_ok_banner_propose_myselectra'
            : 'subscriptionForm:fidelity_maximizer_module.pdl_ok_banner',
        )}
      />

      {canShowActionCard && (
        <>
          <SDNotification type='info' border primaryText={scriptHtml}>
            {/* @ts-ignore */}
            <SDButton block={true} isLoading={actionLoading || loading} onClick={triggerAction}>
              {t(`subscriptionForm:fidelity_maximizer_module.${copyKey}.cta`)}
            </SDButton>
          </SDNotification>
          <p style={{ fontSize: '0.85rem', marginTop: '0.5rem' }}>
            {t(`subscriptionForm:fidelity_maximizer_module.${copyKey}.info`)}
          </p>
        </>
      )}
    </>
  )
}

export default FidelityMaximizer
